import { Box, Button, Modal, IconButton, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Bars } from "react-loader-spinner";
import { useMessage } from "../../../base/MessageProvider";
import { kycConfirmation } from "../../actions/kyc";
import { Close, East, Verified, West } from "@mui/icons-material";
import ValueContainer from "../DetailContainer/ValueContainer";
import DropdownContainer, {
  Datatype,
} from "../DetailContainer/DropdownContainer";
import ReactSelect from "../../../components/ControllerComponent/ReactSelect";
import { contactPrivacyOptions } from "../../../constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { format } from "date-fns";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const boxStyle = {
  maxWidth: 700,
  width: "90%",
  bgcolor: "white",
  paddingX: 5,
  paddingY: 2,
  borderRadius: "18px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const schema = yup
  .object({
    experienceCategory: yup
      .string()
      .required("Experience Category is required"),
  })
  .required();

const KycConfirmationModal = ({
  open,
  onClose,
  item,
  onSuccess,
  onNext,
  onPrevious,
  prevDisabled = false,
  nextDisabled = false,
}) => {
  const {
    control,
    handleSubmit,
    clearErrors,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      experienceCategory: "",
    },
  });

  const dispatch = useDispatch();
  const alert = useMessage();
  const loading = useSelector((state) => state.recruiterAuthReducer?.loading);
  const [transformedExperienceList, setTransformedExperienceList] = useState(
    []
  );

  const profilePic = item?.userProfile?.profilePic?.url;
  const currentLook = item?.kycMedia?.url;
  const experienceCategoryList = item?.experienceCategoryList;
  const profileType = item?.userProfile?.profileCategory?.type;

  const recruiterExperienceCategoryList =
    useSelector(
      (state) => state.generalReducer?.recruiterExperienceCategoryList
    ) ?? [];

  const artistExperienceCategoryList =
    useSelector(
      (state) => state.generalReducer?.artistExperienceCategoryList
    ) ?? [];

  useEffect(() => {
    const transformList = (list) => {
      return list.map((item) => ({
        label: item,
        value: item,
      }));
    };

    const selectedList =
      profileType === "RECRUITER"
        ? recruiterExperienceCategoryList
        : artistExperienceCategoryList;

    setTransformedExperienceList(transformList(selectedList));
  }, [
    profileType,
    recruiterExperienceCategoryList,
    artistExperienceCategoryList,
  ]);

  console.log(
    "Print Profile category type here >>> ",
    recruiterExperienceCategoryList,
    artistExperienceCategoryList
  );

  const contactDetail = item
    ? [
        { label: "Email", value: item?.email },
        { label: "Mobile No", value: item?.mobileNo },
      ]
    : [];

  // useEffect(() => {
  //   const checkAuthentications = async () => {
  //     const signupToken = localStorage.getItem(StorageConstants.SIGNUP_TOKEN);
  //     if (!signupToken) {
  //       navigate("/admin/login", { replace: true });
  //       return;
  //     }
  //   };
  //   checkAuthentications();
  // }, []);

  const onRejectHandle = async (data) => {
    dispatch(
      kycConfirmation(
        {
          kycId: item?.kycId,
          status: "DENIED",
        },
        (res) => {
          onSuccess("DENIED");
          alert.showSuccess(res?.message ?? "Successfully Rejected");
          onClose();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
  };

  const onApproveHandle = async (data) => {
    console.log("print data of experience category >>> ", data);
    dispatch(
      kycConfirmation(
        {
          kycId: item?.kycId,
          experienceCategory: data?.experienceCategory,
          status: "APPROVED",
        },
        (res) => {
          onSuccess("APPROVED");
          alert.showSuccess(res?.message ?? "Successfully Approved");
          onClose();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
  };

  return (
    <Modal
      onClose={onClose}
      disableAutoFocus
      sx={{ bgcolor: "#F4F4F499" }}
      // hideBackdrop
      open={open}
    >
      <Box
        className="w-full flex items-center justify-center gap-4 h-full "
        sx={style}
      >
        {onPrevious && (
          <IconButton
            disabled={prevDisabled}
            className={
              prevDisabled ? "bg-[#0000004d] bg-opacity-10" : "bg-[#000000b7]"
            }
            onClick={onPrevious}
          >
            <West className="text-4xl text-white" />
          </IconButton>
        )}
        <Box className="shadow-[0_0_14px_grey] relative" sx={boxStyle}>
          {/* <Box className="mb-4"> */}
          <Box>
            <div className="absolute right-2 top-1 z-10 ">
              <IconButton onClick={onClose} className="rounded-full">
                <Close className="text-2xl rounded-full" />
              </IconButton>
            </div>
            <h2 className="font-['Poppins-Medium'] font-[500] text-[14px]">
              Please Verify The Profile For KYC Verification
            </h2>
          </Box>
          <div className="flex justify-center">
            <div className="w-[50%] relative h-[250px] flex flex-col justify-center items-center my-3  border-[#EDECEC] mx-2">
              {/* Your existing code for image goes here */}
              <h1 className="font-['CG-Medium'] case normal-case font-[400] text-[13px] text-[#000] my-2">
                Profile Pic
              </h1>
              <img
                alt="current look"
                className="h-full object-cover aspect-[16/12] border-[1px] border-[#EDECEC]"
                src={
                  profilePic
                    ? profilePic
                    : require("../../../assets/images/user-img.png")
                }
              />
            </div>
            <div className="w-[50%] relative h-[250px] flex flex-col justify-center items-center my-3 mx-2">
              {/* Your existing code for image goes here */}
              <h1 className="font-['CG-Medium'] case normal-case font-[400] text-[13px] text-[#000] my-2">
                Current Look
              </h1>
              <img
                alt="profile pic"
                className="h-full object-cover aspect-[16/12]  border-[1px]  border-[#EDECEC]"
                src={
                  currentLook
                    ? currentLook
                    : require("../../../assets/images/user-img.png")
                }
              />
            </div>
          </div>

          <div className="h-full w-full flex flex-col justify-between pb-7 overflow-y-auto">
            {item && (
              <div className="flex w-full gap-4">
                <div className="flex-1">
                  {/* <Divider /> */}
                  <ValueContainer
                    label={"PROFILE NAME"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {`${item?.firstName} ${item?.lastName ?? ""}`}
                        {item?.verified && (
                          <Verified className="text-[#5D43FF] text-[14px]" />
                        )}
                      </div>
                    }
                  />

                  <Divider />
                  <ValueContainer
                    label={"EMAIL"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.email}
                      </div>
                    }
                  />

                  <Divider />
                  <ValueContainer
                    label={"MOBILE NO"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.mobileNo}
                      </div>
                    }
                  />

                  <Divider />
                  <ValueContainer
                    label={"GENDER"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.gender}
                      </div>
                    }
                  />

                  <Divider />
                  <ValueContainer
                    label={"LOCATION"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.location}
                      </div>
                    }
                  />
                  <Divider />
                  <ValueContainer
                    label={"EXPERIENCE YEARS"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.experienceYears}
                      </div>
                    }
                  />

                  {/* <Divider />
                  <DropdownContainer
                    type={Datatype.LIST}
                    label="CONTACT INFO"
                    data={contactDetail}
                  /> */}
                </div>
                <div className="flex-1">
                  {/* <Divider /> */}
                  <ValueContainer
                    label={"CATEGORY"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.profileCategories
                          ?.map?.((item) => item.name)
                          ?.join?.(", ") ?? ""}
                      </div>
                    }
                  />
                  <Divider />
                  <ValueContainer
                    label={"CONTACT PRIVACY"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.contactVisibility}
                      </div>
                    }
                  />
                  {/* <Divider />
                  <ValueContainer
                    label={"KYC STATUS"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.kycStatus !== null && item?.kycStatus
                          ? item?.kycStatus
                          : "KYC NOT GENERATED"}
                      </div>
                    }
                  /> */}
                  <Divider />
                  <ValueContainer
                    label={"BUSINESS EMAIL"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.businessEmail}
                      </div>
                    }
                  />
                  <Divider />
                  <ValueContainer
                    label={"BUSINESS MOBILE NO"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.businessMobileNo}
                      </div>
                    }
                  />
                  <Divider />
                  <ValueContainer
                    label={"NATIONALITY"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.nationality}
                      </div>
                    }
                  />
                  <Divider />
                  <ValueContainer
                    label={"DATE OF BIRTH"}
                    displayValue={
                      <div className="flex gap-1 items-center">
                        {item?.userProfile?.dob
                          ? format(
                              new Date(item?.userProfile?.dob),
                              "dd MMMM yyyy"
                            )
                          : "-"}
                      </div>
                    }
                  />
                </div>
              </div>
            )}
          </div>

          <div className="flex-1 w-full">
            <ReactSelect
              hookFormControl={control}
              label="Experience Category"
              varName="experienceCategory"
              key={"experienceCategory"}
              withSelect={false}
              options={transformedExperienceList ?? []}
              errorMessage={errors?.experienceCategory?.message}
            />
          </div>

          <div
            className={clsx("flex gap-3 justify-center w-full rounded-full ")}
          >
            <Button
              onClick={onRejectHandle}
              disabled={loading}
              className={clsx(
                "bg-[#D92121] flex gap-3 justify-center text-[#FFF] w-full rounded-full mb-2 mt-3 font-['Poppins-Medium'] font-[500]",
                { "bg-opacity-70": loading }
              )}
            >
              Reject
              <Bars
                height="20"
                width={"20"}
                color="#FFFFFF"
                ariaLabel="bars-loading"
                visible={loading}
              />
            </Button>
            <Button
              onClick={handleSubmit(onApproveHandle)}
              disabled={loading}
              className={clsx(
                "bg-[#2F80ED] flex gap-3 justify-center text-[#FFF] w-full rounded-full mb-2 mt-3 font-['Poppins-Medium'] font-[500]",
                { "bg-opacity-70": loading }
              )}
            >
              Approve
              <Bars
                height="20"
                width={"20"}
                color="#FFFFFF"
                ariaLabel="bars-loading"
                visible={loading}
              />
            </Button>
          </div>
        </Box>
        {onNext && (
          <IconButton
            disabled={nextDisabled}
            className={
              nextDisabled ? "bg-[#0000004d] bg-opacity-10" : "bg-[#000000b7]"
            }
            onClick={onNext}
          >
            <East className="text-4xl text-white" />
          </IconButton>
        )}
      </Box>
    </Modal>
  );
};

export default React.memo(KycConfirmationModal);
